import { z } from "zod";

import { looseArray } from "../looseParse";

export const getCurrencyCloudAccountResponseSchema = z.object({
  account_number: z.string(),
  account_holder_name: z.string(),
  bank_name: z.string(),
  bank_address: z.string(),
  routing_code: z.string(),
  routing_code_type: z.string(),
});

export const getCurrencyCloudStatusResponseSchema = z.object({
  sub_account_exists: z.string(),
  beneficiary_exists: z.string(),
});

export const currencyCloudTransferSchema = z.object({
  id: z.string(),
  account_id: z.string(),
  amount: z.string(),
  direction: z.string(),
  status: z.string(),
  created_at: z.string(),
  updated_at: z.string(),
});

export const currencyCloudBeneficiarySchema = z.object({
  account_number: z.string().nullish(),
  iban: z.string().nullish(),
  bic_swift: z.string().nullish(),
  sort_code: z.string().nullish(),
  aba: z.string().nullish(),
  bsb_code: z.string().nullish(),
  bank_code: z.string().nullish(),
  branch_code: z.string().nullish(),
  clabe: z.string().nullish(),
  cnaps: z.string().nullish(),
  ifsc: z.string().nullish(),
});

export const getCurrencyCloudBeneficiaryResponseSchema = z.object({
  required_details: looseArray(
    currencyCloudBeneficiarySchema,
    "getCurrencyCloudBeneficiaryResponseSchema.required_details",
  ),
});
